<template>
  <Portal to="app-popup">
    <PopupBase
      :label="label"
      :entityName="entityName"
      :documentId="documentId"
      @close="$router.back()"
      @saveMethod="saveAction"
      @hideMethod="onHidden"
      :okTitle="okTitle"
      :cancelTitle="cancelTitle"
      :isBusy="isBusy"
      :isLarge="isLarge"
      :showLeftIcon="showLeftIcon"
      :leftIcon="leftIcon"
      :modalClass="modalClass"
      v-bind="$attrs"
      
    >
      <template #modal-header-left-button>
        <slot name="modal-header-left-button"></slot>
      </template>
      <slot name="backdrop" slot="backdrop"/>
      <slot/>
      <template #modal-left-button>
        <slot name="modal-left-button"></slot>
      </template>
      <template #modal-action-button>
        <slot name="modal-action-button"></slot>
      </template>
    </PopupBase>
  </Portal>
</template>

<script>
import PopupBase from './PopupBase.vue';

export default {
  name: 'PopupRouterView',
  props: {
    isLarge: {
      default: true,
      type: Boolean,
    },
    label: {
      required: true,
      type: String,
    },
    entityName: {
      type: String,
    },
    documentId: {
      type: String,
    },
    okTitle: {
      default: 'Simpan',
      type: String,
    },
    cancelTitle: {
      default: 'Batal',
      type: String,
    },
    isBusy: {
      default: false,
      type: Boolean,
    },
    showLeftIcon: {
      type: Boolean,
      default: false
    },
    leftIcon: {
      default: 'add-icon.png',
      type: String,
    },
    modalClass: {
      default: 'router-view-page',
      type: String,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('ready');
    });
  },
  methods: {
    saveAction(modalEvent) {
      this.$emit("saveMethod", modalEvent);
    },
    onHidden() {
      this.$emit("onHideMethod");
    }
  },
  components: {
    PopupBase,
  },
};
</script>